import configs from '../config';
import { fetchWithTenant } from '../utils/apiClient';

const API_BASE_URL = `${configs.BACKEND_URL}/api/analytics`;

function buildQueryString(params = {}) {
  const filtered = Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      acc[key] = value;
    }
    return acc;
  }, {});
  const qs = new URLSearchParams(filtered).toString();
  return qs ? `?${qs}` : '';
}

async function fetchJson(url, options) {
  const response = await fetchWithTenant(url, options);
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || data.error || 'Request failed');
  }
  return response.json();
}

export async function getDashboardAnalytics(params = {}) {
  return fetchJson(`${API_BASE_URL}/dashboard${buildQueryString(params)}`);
}

export async function getProposalAnalytics(params = {}) {
  return fetchJson(`${API_BASE_URL}/proposals${buildQueryString(params)}`);
}

export async function getRelevanceAnalysis(params = {}) {
  return fetchJson(`${API_BASE_URL}/relevance${buildQueryString(params)}`);
}

export async function getResponseTracking(params = {}) {
  return fetchJson(`${API_BASE_URL}/responses${buildQueryString(params)}`);
}

export async function getSubmissionMetrics(params = {}) {
  return fetchJson(`${API_BASE_URL}/submissions${buildQueryString(params)}`);
}

export async function exportAnalyticsData(params = {}) {
  const response = await fetchWithTenant(`${API_BASE_URL}/export${buildQueryString(params)}`);
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || data.error || 'Failed to export analytics data');
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `analytics-${params.type || 'data'}-${new Date().toISOString().split('T')[0]}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return { success: true };
}

const analyticsService = {
  getDashboardAnalytics,
  getProposalAnalytics,
  getRelevanceAnalysis,
  getResponseTracking,
  getSubmissionMetrics,
  exportAnalyticsData
};

export default analyticsService;
